import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    footer: {
        marginTop: '20%',
        padding: '.1rem',
        backgroundColor: 'grey',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '193px',
      }
}));
